import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import { HomepageService } from '../../services/homepage.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  	selector: 'app-print',
  	templateUrl: './print.component.html',
  	styleUrls: ['./print.component.css'],
   encapsulation: ViewEncapsulation.None
})
export class PrintComponent implements OnInit {
	listType: any = '';
	listData: any = [];
	sortBy:any = 'date';
	libraryname:any = '';
	descending:boolean = true;
	listSize: number = 10000;
	caption: string = '';
	facets: any = [];
	librarySetting: any=[];
  	constructor(private activatedRoute: ActivatedRoute,private cookieService: CookieService, private homepageService: HomepageService) { 
  		this.activatedRoute.queryParams.subscribe(params => {
  			this.listType =  params['print'];
  		});
  	}
  	ngOnInit() {

  		this.homepageService.getConfig().subscribe((setting) => {
  			this.librarySetting = setting;
  			var tnt = this.librarySetting.data.tenantCode.toLowerCase();
			var slctloc = this.cookieService.get('selectedlocation'+tnt);            
			this.librarySetting.data.settings.location.locations.forEach((loc) =>{
			if(parseInt(loc.id) == parseInt(slctloc) ){
				this.libraryname = loc.name;
			}
			});
  		});  
		
  		if(this.listType == 'pt'){
  			this.popularTitles();
  		} else if(this.listType == 'nil'){
  			this.newInLibrary();
  		}
  	}

  	popularTitles(){
  		this.homepageService.getPopularPage(this.sortBy,this.descending,this.listSize,this.facets).subscribe((data:any) => {
  			this.listData = data.data.resources;
  			this.caption = data.data.caption;
  			var self = this;
  			setTimeout(function(){
  				var content = $('main').html();
  				self.printFnWithHtml(content,self.libraryname);  				
  			},500);
  		});
  	}

  	newInLibrary(){
  		this.homepageService.getNewInLibararyPage(this.sortBy,this.descending,this.listSize,this.facets).subscribe((data:any) => {
  			this.listData = data.data.resources;
  			this.caption = data.data.caption;
  			var self = this;
  			setTimeout(function(){
  				var content = $('main').html();  			
  				self.printFnWithHtml(content,self.libraryname);  				
  			},500);
  		});
  	}


    printFnWithHtml(content,libraryName){
    	var mywindow = window.open('');
    	mywindow.document.write('<html><head><title>Print</title><link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i" rel="stylesheet"><style>@font-face {font-family: "Material Icons";font-style: normal;font-weight: 400;src: url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");}.material-icons {font-family: "Material Icons";font-weight: normal;font-style: normal;font-size: 24px;line-height: 1;letter-spacing: normal;text-transform: none;display: inline-block;white-space: nowrap;word-wrap: normal;direction: ltr;-moz-font-feature-settings: "liga";-moz-osx-font-smoothing: grayscale;} body{font-family:"Roboto", sans-serif !important;} p {color:#8c8c8c;}.hangingindent {padding-left: 36px ;text-indent: -36px; }.book-box {display:flex;border-bottom: 1px dashed rgba(0, 0, 0, 0.1);padding: 7px 0;width: 100%;position: relative;}.book-image {height: auto;overflow:hidden;border: 1px solid rgba(0, 0, 0, 0.1);float: left;padding: 4px;width: 55px;}.book-box .book-box-head {color: #26B6EF;float: left;font-size: 16px;font-weight: 600;padding: 0 0px 0 0;}.book-box .book-image .book-box-head { margin: 0px 0 0px;}.book-image a {width: 100%;}.book-box-head {text-decoration: none;color: #1e1e1e !important;margin: 0 0 5px 0;}.book-image img {float: left;height: 100%;-o-object-fit: cover;object-fit: cover;width: 100%;vertical-align: middle;border-style: none;}.book-box-info {width: calc(100% - 50px);float: left;padding-left: 20px;} .book-box .book-box-info .book-box-head { width: calc(100% - 130px);}.book-box h4 {text-transform: uppercase;background: #f6f6f6 none repeat scroll 0 0;float: right;font-size: 12px;font-weight: 600;margin: 5px 0 0;padding: 0px 10px;}.author {float: left;font-size: 14px;padding: 4px 0;margin: 0;width: 100%;}.star-rating {display: none;}.book-box .description {float: left;font-size: 13px;font-weight: 400;margin: 5px 0 10px;width: 100%;line-height: 20px;color: #666;}.book-box-bottom{display: none;}.Placeholders {height:60px;  width: 100%;    display: flex;  box-shadow: 0px 0px 1px #F2F2F2;  color: #ffffff; overflow:hidden; padding: 0px 0;  text-align: center;  align-items: center;  justify-content: center;}.Placeholders.primary {background-color: #177BBB;}.Placeholders.info {background-color: #03A9F4;}.Placeholders.success {background-color: #8BC34A;}.Placeholders.mint {background-color: #26A69A;}.Placeholders.warning {background-color: #FFB300;}.Placeholders.danger {  background-color: #F44336;}.Placeholders.purple {background-color: #AB47BC;}.Placeholders.pink {background-color: #F06292;}.Placeholders.datk {background-color: #3A444E;}.Placeholders.gray { background-color: #E9EEEF;}.material-icons {font-size: 30px !important;color: #fff;}.description {display: none;}h2.caption{text-align: center;margin: 0;padding: 3px 0;float: left;width: 100%;}h4.libraryname{text-align: center;margin-bottom: 40px;}</style>');
		mywindow.document.write('</head><body>');    
		mywindow.document.write(content);
		mywindow.document.write('</body></html>');
		mywindow.document.close();
		mywindow.onload = function () {
			const images = mywindow.document.images;
			let loaded = 0;
			function triggerPrint() {
				mywindow.focus();
				mywindow.print();
			}
			if (images.length === 0) {
				setTimeout(triggerPrint, 300);
			} else {
				Array.from(images).forEach((img) => {
				if (img.complete) {
					loaded++;
					if (loaded === images.length) setTimeout(triggerPrint, 300);
				} else {
					img.onload = img.onerror = () => {
					loaded++;
					if (loaded === images.length) setTimeout(triggerPrint, 300);
					};
				}
				});
			}
		};
		mywindow.onafterprint = function () {
			mywindow.close();
		};
		return true;
	 }



  	imageError(event){
      $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').remove();
    }
  
   	imageLoad(event, images) {
    	if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes') {
      		return false;
    	}
    	var sizes = ['xl','l','m','s','xs','xxs'];
    	if($('body').find('#TempImg').length <= 0) {
       		$('body').append('<img id="TempImg" src="" style="display:none;">');
    	}
    	var imagesAll = [];
    	sizes.forEach((evt) => {
      		images.forEach((img) => {
        		if(img.size == evt){
          		imagesAll.push(img.url);
        		}
      		});      
    	});     
    	setTimeout(function() {
      		if(typeof(imagesAll[0]) != 'undefined') {
        		$('body').find('img[custom="'+event+'"]').attr('src',imagesAll[0]);
        		$('body').find('img[custom="'+event+'"]').attr('loaded','yes');
      		}
		},10);
  	}
}
